import { SampleStatusCard } from '@design-system/Cards/SampleStatusCard';
import { NavBar } from '@design-system/NavBar';
import { Skeleton } from '@design-system/Skeleton';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { ErrorLoadingPage } from '@/components/screens/ErrorHandling/ErrorLoadingPage';

export const TrackSamplesStatusPage = () => {
  const { data: samples, isLoading, error } = useGetSampleDetailsQuery();

  if (error) {
    return <ErrorLoadingPage />;
  }

  if (!samples?.length && !isLoading) {
    return (
      <section className="page-container flex flex-col gap-12" data-testid="trackSamples-noSamplesPage">
        <div className="flex flex-col gap-6 md:gap-12" data-testid="trackSamples-noSamplesHeader">
          <NavBar
            buttonLabel={<span className="max-md:hidden">Account</span>}
            data-testid="trackSamples-noSamplesNavbar"
          />
          <h1 className="typography-body text-primary text-center" data-testid="trackSamples-noSamplesMessage">
            There are no test results or sample statuses to display.
          </h1>
        </div>
      </section>
    );
  }

  return (
    <section className="page-container flex flex-col gap-12" data-testid="trackSamples-page">
      <div className="flex flex-col gap-6 md:gap-12" data-testid="trackSamples-header">
        <NavBar buttonLabel={<span className="max-md:hidden">Account</span>} data-testid="trackSamples-navbar" />
        <h1 className="typography-h1 text-primary" data-testid="trackSamples-title">Track Sample Status</h1>
      </div>
      <ul className="flex flex-col gap-4" data-testid="trackSamples-list">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="w-full h-52" data-testid={`trackSamples-skeleton-${index}`} />
          ))
        ) : (
          samples?.map((sample) => (
            <li key={sample.sample_information.sample_id} data-testid={`trackSamples-item-${sample.sample_information.sample_id}`}>
              <SampleStatusCard sample={sample} data-testid={`trackSamples-statusCard-${sample.sample_information.sample_id}`} />
            </li>
          ))
        )}
      </ul>
    </section>
  );
};